import { serializeTitle } from '@/utils/index.js'

export default {
  path: '/collection/references',
  component: () => import(/* webpackChunkName: "reference" */ '@/views/Reference.vue'),
  children: [{
    path: '/',
    name: 'ListReference',
    component: () => import(/* webpackChunkName: "reference" */ '@/components/reference/List.vue'),
    meta: {
      title: serializeTitle('Votre Collection'),
      requiresAuth: true,
      requiresCustomer: true,
    },
  }, {
    path: ':id(\\d+)',
    name: 'ShowReference',
    component: () => import(/* webpackChunkName: "reference" */ '@/components/reference/Show.vue'),
    meta: {
      title: serializeTitle('Page Référence'),
      requiresAuth: true,
      requiresCustomer: true,
    },
  }]
}